import React, { useRef } from 'react';
import { Button } from 'primereact/button';
import { Menu }   from 'primereact/menu';

export default function AssetsTableRow({
   asset,
   handleAssignLayer,
   handleAddNote,
   handleEditLocation ,
   handleEditGeneral
}) {
  const menu = useRef(null);

  // Helper to hide menu and release focus before opening modals
  const withMenuClose = (handler) => (e) => {
    // Prevent event propagation to avoid triggering other handlers
    if (e && e.originalEvent) {
      e.originalEvent.stopPropagation();
      e.originalEvent.preventDefault();
    }
    // Blur any focused menu item to prevent aria-hidden focus conflict
    if (document.activeElement) {
      document.activeElement.blur();
    }
    // Close the menu - PrimeReact Menu automatically closes on item click,
    // but we can explicitly hide it if needed. The menu should close naturally.
    // Small delay to let menu fully close before modal opens
    setTimeout(() => {
      handler(asset);
    }, 50);
  };

  const items = [
    {
      label: 'Assign Layer',
      icon: 'pi pi-pencil',
      command: withMenuClose(handleAssignLayer),
    },
    // {
    //   label: 'Add Note',
    //   icon: 'pi pi-comment',
    //   command: withMenuClose(handleAddNote),
    // },
    {
      label: 'Edit Location',
      icon: 'pi pi-map-marker',
      command: withMenuClose(handleEditLocation),
    },
    {
      label: 'General Edit',
      icon: 'pi pi-cog',
      command: withMenuClose(handleEditGeneral),
    }
  ];

  return (
    <>
      <Button
        label="Edit"
        icon="pi pi-angle-down"
        iconPos='right'
        onClick={(event) => menu.current.toggle(event)}
        aria-controls="asset-row-menu"
        aria-haspopup
        text
      />
      <Menu
        id="asset-row-menu"
        model={items}
        popup
        ref={menu}
      />
    </>
  );
}